export class SortExpression {
  SortField: string;
  SortDirection: SortDirectionEnum;
}

export enum SortDirectionEnum {
  Asc,
  Desc,
}
